import { VIDEO_TEMPLATES } from './videoTemplates'

// Full-prompt suggestions drawn from our curated templates, plus a handful
// of shorter openers that cover common phrasings users reach for.
const EXTRA_STARTERS: string[] = [
  'Premium product on a white marble countertop, golden hour lighting streaming through sheer curtains',
  'Slow forward dolly toward the product with shallow depth of field',
  'Macro close-up of the product label and texture, dramatic single side light',
  'Elegant feminine hand reaches into frame and picks up the product',
  'Product rotates slowly on a clean matte white surface, soft diffused studio lighting',
  'Overhead flat-lay of the product surrounded by natural props on linen',
  'Dark moody bathroom vanity with candlelight reflections',
  'Product stands on reflective wet black marble with ripple patterns',
  'Cinematic product video, premium lighting, smooth camera movement',
  'Woman in a sunlit room picks up the product and glows',
]

export const PROMPT_SUGGESTIONS: string[] = Array.from(
  new Set([
    ...VIDEO_TEMPLATES.map((t) => t.prompt),
    ...EXTRA_STARTERS,
  ]),
)

/**
 * Return the unwritten tail of a suggestion whose prefix matches `input`,
 * or `null` if nothing matches. Case-insensitive on the prefix compare,
 * but the returned tail preserves the casing of the suggestion.
 *
 * Requires at least 3 non-whitespace chars so we don't spam suggestions
 * on every keystroke in an empty field.
 */
export function findPromptSuggestion(
  input: string,
  list: readonly string[] = PROMPT_SUGGESTIONS,
): string | null {
  if (input.trim().length < 3) return null

  const lower = input.toLowerCase()
  const match = list.find((s) => s.toLowerCase().startsWith(lower))
  if (!match) return null
  if (match.length <= input.length) return null

  return match.slice(input.length)
}
